"use client";

import { ArrowRight, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FinalCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="services-final-cta" id="services-final-cta" className="bg-background text-foreground py-20 md:py-28">
      <div className="container mx-auto px-6 md:px-8 max-w-5xl text-center">
        <div ref={ref} className={`border border-border bg-card rounded-md p-8 md:p-14 shadow-lg transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="block h-px w-8 bg-primary" />
            <span className="font-mono text-xs uppercase tracking-widest text-primary">
              Take The Next Step
            </span>
            <span className="block h-px w-8 bg-primary" />
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground mb-6 tracking-tight">
            Schedule Your Free Property Inspection Today
          </h2>

          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed mb-8 font-sans">
            Protect your property from foundation to roofline. Reach out to our family-owned team for a prompt evaluation and honest recommendations.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild className="rounded-md h-auto px-7 py-3.5 text-base font-bold font-default bg-primary text-primary-foreground hover:bg-primary/90 transition-all shadow-md w-full sm:w-auto">
              <Link to="/ContactPage">
                Get Your Free Inspection
                <ArrowRight className="ml-2 size-4" />
              </Link>
            </Button>

            <Button asChild variant="outline" className="rounded-md h-auto px-7 py-3.5 text-base font-bold font-default border-[1.5px] border-primary text-foreground hover:bg-primary hover:text-primary-foreground transition-all w-full sm:w-auto">
              <Link href="tel:9198961953">
                <Phone className="mr-2 size-4 text-primary" />
                Call 919-896-1953
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}